import script from "./CompSet.vue?vue&type=script&setup=true&lang=js"
export * from "./CompSet.vue?vue&type=script&setup=true&lang=js"

import "./CompSet.vue?vue&type=style&index=0&id=c4464148&lang=css"

const __exports__ = script;

export default __exports__